/* Not loaded on the storefront: the theme loads popup-quick-shop.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in popup-quick-shop.min.js. */
(() => {
  // app/scripts/popup-quick-shop.js
  customElements.define("popup-quick-shop", class extends HTMLElement {
    constructor() {
      super();
      this.productUrl = this.dataset.productUrl;
      const btnTriggers = this.querySelectorAll("#popupQuickview .jsTrigger");
      btnTriggers === null || btnTriggers === void 0 || btnTriggers.forEach(btn => {
        btn.addEventListener("click", () => {
          const e_parent = btn.parentElement;
          e_parent.classList.contains("active") ? e_parent.classList.remove("active") : e_parent.classList.add("active");
        });
      });
      let tab_controls = this.querySelectorAll(".tab_control");
      tab_controls === null || tab_controls === void 0 || tab_controls.forEach(e => {
        e.addEventListener("click", eve => {
          eve.preventDefault();
          window.location.href = this.productUrl;
          localStorage.setItem("tab_control", e.dataset.target);
        });
      });
    }
  });
})();
